import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/nft/image-3.webp")